import React from "react";
import { CSSTransition } from "react-transition-group";

const Callout = props => (
	<CSSTransition in={props.show} unmountOnExit timeout={1000} classNames="callout">
		<div
			className={`callout${props.warn ? " callout__warn" : props.danger ? " callout__danger" : props.success ? " callout__success" : props.criticalWarn ? " callout__danger" : ""}`}
		>
			<div className="callout--icon">
				<i className={`icon-${props.danger ? "close" : props.warn || props.criticalWarn ? "exclamation" : "check icon-color"}`} />
			</div>
			<div className="callout--text">{props.text}</div>
		</div>
	</CSSTransition>
);

export default Callout;
